import { useQuery } from '@tanstack/react-query'

const SAFE_SLUG = /^[a-zA-Z0-9][a-zA-Z0-9/_-]*$/

function fetchHelpArticle (slug) {
  return fetch(`/help-content/${slug}.md`)
    .then(res => {
      if (!res.ok) throw new Error('Article not found')
      return res.text()
    })
}

function useHelpContent (slug) {
  const { data: content, isLoading, error } = useQuery({
    queryKey: ['help-content', slug],
    queryFn: () => fetchHelpArticle(slug),
    enabled: !!slug && SAFE_SLUG.test(slug),
    staleTime: 5 * 60 * 1000
  })

  return { content: content ?? null, isLoading, error: error ?? null }
}

export default useHelpContent
